import { showToast, toast } from './toast';

export const sendNotification = (heading, text, position = 'top-center') => {
  showToast({ heading, text, position });
};

export const registerNotificationApp = () => {
  window.daToast = { send: sendNotification, show: toast };
};
